var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_415_3234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16.0972C32 24.0825 26.1413 30.7025 18.4933 31.9038V20.7532H22.212L22.92 16.1398H18.4933V13.1465C18.4933 11.8838 19.112 10.6545 21.0933 10.6545H23.1053V6.7265C23.1053 6.7265 21.2787 6.4145 19.5333 6.4145C15.888 6.4145 13.5067 8.62383 13.5067 12.6225V16.1385H9.45467V20.7518H13.5067V31.9025C5.86 30.6998 0 24.0812 0 16.0972C0 7.26117 7.164 0.097168 16 0.097168C24.836 0.097168 32 7.25984 32 16.0972Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_415_3234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.644c45c6a479cd29ab262fd9cac84a29.svg";
export { ForwardRef as ReactComponent };